import { z } from 'zod';

// TODO: format price
export const PriceSchema = z.object({
  amount: z.number(),
  currency: z.string(),
  symbol: z.string(),
});
